import { render, staticRenderFns } from "./RateResearch.vue?vue&type=template&id=7594b092&scoped=true&"
import script from "./RateResearch.vue?vue&type=script&lang=js&"
export * from "./RateResearch.vue?vue&type=script&lang=js&"
import style0 from "./RateResearch.vue?vue&type=style&index=0&id=7594b092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7594b092",
  null
  
)

export default component.exports